import React, { useEffect, useState } from 'react';
import img from '../assets/footer-logo.webp';
import img1 from '../assets/insta-img.webp';
import img2 from '../assets/facebook-img.svg';

const Footer = () => {
  const [showChatIcon, setShowChatIcon] = useState(false);
  const handleScroll = () => setShowChatIcon(window.scrollY > 0);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-4 mb-32">
              <a href="#">
                <img src={img} alt="Footer Logo" className="footer-logo" loading="lazy" />
              </a>
              <p className="footer-p">
                PoolWater-Pro Test-Strip technologies enable fast, convenient and accurate water analysis for your pool.
              </p>
            </div>
            <div className="col-md-8">
              <ul className="footer-ul flex-wrap">
                <li><a href="https://poolwater-pro.com/privacy-policy/">Privacy Policy</a></li>
                <li><a href="https://poolwater-pro.com/terms-of-use/">Terms of Use</a></li>
                <li><a href="javascript:void(0);" className="show_paid_plans">See Our Pricing</a></li>
              </ul>
            </div>
            <div className="col-12">
              <div className="sub-footer">© 2025 PoolWater-Pro. All rights reserved.</div>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating Button */}
      {showChatIcon && (
        <a href="#!" className="landing-slider-button fs-btn-signup-floating">
          <span>Try for Free!</span>
        </a>
      )}

      <style>{`
        .fs-btn-signup-floating {
          position: fixed;
          bottom: 24px;
          right: 24px;
          z-index: 99999;
          background-color: #E22B2B;
          border: none;
          padding: 0;
          cursor: pointer;
          border-radius: 100%;
          box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.5);
          text-decoration: none;
          width: 80px;
          height: 77px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .fs-btn-signup-floating span {
          color: #ffffff;
          transform: rotateZ(-10deg);
          width: 88%;
          font-family: "Poppins", Sans-serif;
          font-weight: 600;
          font-size: 12px;
          text-align: center;
          line-height: 1.2;
        }
      `}</style>
    </div>
  );
};

export default Footer;
